
      if (import.meta.env.MODE === 'development') {
        await import('/dev-tools/src/error-client.ts')
      }
      import('/src/main.tsx').catch(err => {
        // Log to console so startup crashes are never invisible.
        console.error('[app] Failed to load main entry:', err);
        window.dispatchEvent(new CustomEvent('vite:initial-error', { detail: err }));
      })
    